import { attributes, html } from 'BomdisoftComponents/html/index';
import { CLOSE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';
import { renderIcon } from 'BomdisoftComponents/icons/render';
import { renderTooltip } from 'BomdisoftComponents/tooltip/render';
import { getLanguageFromLocale, languageOfferAction, languageOfferActionShort, languageOfferBody, languageOfferDismiss, languageOfferName, type SupportedLanguageCode } from '@bomdisoft/translations';

export const LANGUAGE_OFFER_TAG = 'bomdisoft-language-offer';

export const DEFAULT_LANGUAGE_OFFER_TEST_ID = 'language-offer';

export type LanguageOfferCopy = {
  action: string;
  actionShort: string;
  dismiss: string;
  lead: string;
  name: string;
  trail: string | undefined;
};

export const toLanguageOfferCopy = (offered: SupportedLanguageCode): LanguageOfferCopy => {
  const language = getLanguageFromLocale(offered);
  const name = languageOfferName[language];
  const [lead, trail] = languageOfferBody[language].split('{language}');
  return { action: languageOfferAction[language].replace('{language}', name), actionShort: languageOfferActionShort[language], dismiss: languageOfferDismiss[language], lead, name, trail };
};

export type LanguageOfferOptions = {
  offered: SupportedLanguageCode;
  testId?: string;
  tooltipId?: string;
};

export const renderLanguageOffer = ({ offered, testId = DEFAULT_LANGUAGE_OFFER_TEST_ID, tooltipId = `${testId}-dismiss-tooltip` }: LanguageOfferOptions) => {
  const copy = toLanguageOfferCopy(offered);
  return html`<div${attributes({ class: 'bomdisoft-language-offer', 'data-testid': testId, dir: offered === 'ar' ? 'rtl' : 'ltr', lang: offered })}><p class="bomdisoft-language-offer-text">${copy.lead}<b class="bomdisoft-language-offer-name">${copy.name}</b>${copy.trail}</p><a${attributes({ class: 'bomdisoft-language-offer-action', 'data-testid': `${testId}-action`, href: `/${offered}` })}><span class="bomdisoft-language-offer-action-full">${copy.action}</span><span class="bomdisoft-language-offer-action-short">${copy.actionShort}</span></a>${renderTooltip({ children: html`<button${attributes({ 'aria-label': copy.dismiss, class: 'bomdisoft-language-offer-dismiss', 'data-testid': `${testId}-dismiss`, type: 'button' })}>${renderIcon(CLOSE_ROUNDED_GLYPH, { size: 18 })}</button>`, id: tooltipId, title: copy.dismiss })}</div>`;
};
